<script lang="ts">
	export let url: string;
	export let title: string;
	export let subtitle: string | undefined = undefined;
	export let style: "regular" | "warning" = "regular";
	export let isNew = false;
</script>

<a
	class="flex w-full items-center justify-between rounded-[3px] px-1.5 py-[7px] font-medium text-white transition-all duration-150 ease-linear hover:pr-0.5"
	class:hover:bg-[#0088b2]={style === "regular"}
	class:hover:bg-[#ca5a42]={style === "warning"}
	on:click|stopPropagation
	href={url}>
	<slot>
		{#if subtitle}
			<div class="flex flex-col items-start">
				{title}
				<span class="text-13 font-normal opacity-70">{subtitle}</span>
			</div>
		{:else if isNew}
			<div>
				{title}
				<span class="ml-1 rounded bg-white p-1 text-10 font-bold uppercase tracking-wider text-[#0088b2]" style="vertical-align: 1.5px;">
					new
				</span>
			</div>
		{:else}
			{title}
		{/if}
	</slot>
	<span class="material-icons text-16"> chevron_right </span></a>
